import { ForumError, forumEnvelope, forumError, invalidResponse, staleResponse } from './forumErrors';
import { forumId } from '../models/forumMappers';

export function notificationResult(raw) {
  const { data } = forumEnvelope(raw), counts = data.counts || {};
  if (![data.changed, counts.total, counts.unread].every(n => Number.isSafeInteger(n) && n >= 0) || counts.unread > counts.total) throw invalidResponse();
  return { changed: data.changed, total: counts.total, unread: counts.unread };
}

// Serialize actions across the collection: a bulk change and a row action must
// not race. No automatic POST retries after an uncertain response.
export function createForumNotificationRepository({ http, getIdentity, invalidate = () => {} }) {
  let pending = null;
  const identity = () => JSON.stringify(getIdentity() || {});
  return {
    change(action, item) {
      if (!['read', 'remove', 'read_all', 'remove_all', 'remove_read'].includes(action)) return Promise.reject(invalidResponse());
      const payload = { action }, owner = identity();
      if (!forumId((getIdentity() || {}).uid)) return Promise.reject(staleResponse());
      if (['read', 'remove'].includes(action)) {
        if (!item || !forumId(item.threadId) || !forumId(item.commentId)) return Promise.reject(invalidResponse());
        Object.assign(payload, { thread_id: forumId(item.threadId), comment_id: forumId(item.commentId) });
      }
      const key = JSON.stringify(payload);
      if (pending && pending.owner === owner) return pending.key === key ? pending.promise : Promise.reject(new ForumError('notification_busy', 'Espera a que termine el cambio de avisos en curso.', 409));
      const current = () => { if (identity() !== owner) throw staleResponse(); };
      const request = Promise.resolve().then(() => { current(); return http.post('/forum/api/v2/notifications', payload); }).then(response => {
        current(); const result = notificationResult(response.data);
        try { invalidate(['activity']); } catch (_) { /* Confirmed result stays authoritative. */ }
        return result;
      }).catch(error => {
        current(); const failure = forumError(error);
        if ((!failure.status && failure.code !== 'stale_response') || failure.status >= 500) {
          throw new ForumError('notification_uncertain', 'No se pudo confirmar el cambio. Comprueba el estado de tus avisos antes de continuar.', failure.status);
        }
        throw failure;
      }).finally(() => { if (pending && pending.promise === request) pending = null; });
      pending = { owner, key, promise: request }; return request;
    }
  };
}
